<template>
  <div class="patient-identity">
    <div class="d-flex align-items-center justify-content-between gap-3 mb-2">
      <span class="form-label mb-0">{{ form.is_foreign ? 'RNM/RNE (CRNM)' : 'CPF' }} <span class="text-danger">*</span></span>
      <label class="d-inline-flex align-items-center gap-2 mb-0 small" style="white-space: nowrap; cursor: pointer">
        <input type="checkbox" :checked="form.is_foreign" :disabled="disabled" @change="toggleForeign($event.target.checked)">
        Estrangeiro?
      </label>
    </div>
    <input v-if="form.is_foreign" v-model="form.document_number" class="form-control form-control-solid" :disabled="disabled" maxlength="12" required autocapitalize="characters" placeholder="Ex.: A1234567" aria-label="RNM/RNE" @blur="validate">
    <input v-else v-model="form[cpfField]" v-mask="'###.###.###-##'" class="form-control form-control-solid" :disabled="disabled" required placeholder="000.000.000-00" aria-label="CPF" @blur="validate">
    <div v-if="form.is_foreign" class="mt-3">
      <label class="form-label">Nacionalidade <span class="text-muted small">(opcional)</span></label>
      <select v-model="form.nationality" class="form-select" :disabled="disabled"><option :value="null">Selecione (opcional)</option><option v-for="option in countries" :key="option.value" :value="option.value">{{ option.label }}</option></select>
    </div>
    <div v-if="message" class="mt-1 small" :class="invalid ? 'text-danger' : 'text-muted'" aria-live="polite">{{ message }}</div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import http from '../helpers/http';
export default {
  directives: { mask },
  props: {
    form: { type: Object, required: true },
    cpfField: { type: String, default: 'patient_cpf' },
    disabled: Boolean,
  },
  data: () => ({
    countries: [], message: '', invalid: false, requestVersion: 0,
  }),
  computed: {
    alternative() { return !!this.form.is_foreign; },
    identityKey() { return JSON.stringify([this.form.is_foreign, this.form.nationality, this.form.document_type, this.form.document_country, this.form.document_number, this.form[this.cpfField]]); },
  },
  watch: { identityKey() { this.requestVersion++; this.message = ''; } },
  async mounted() {
    try {
      const { data } = await http.get('/identity-documents/options');
      this.countries = Object.entries(data.countries).map(([value, label]) => ({ value: Number(value), label }));
    } catch { this.invalid = true; this.message = 'Não foi possível carregar os países. Reabra o formulário para tentar novamente.'; }
  },
  methods: {
    toggleForeign(value) {
      this.form.is_foreign = value;
      this.form.nationality = this.form.nationality || null;
      this.form.document_type = value ? 'residence' : null;
      this.form.document_country = value ? 'BR' : null;
      this.form.document_number = null;
      if (value) this.form[this.cpfField] = null;
      else this.form.nationality = null;
    },
    async validate() {
      if (this.disabled) return;
      const version = ++this.requestVersion;
      this.invalid = false; this.message = 'Validando formato…';
      try {
        const { data: validation } = await http.post('/identity-documents/validate', {
          is_foreign: !!this.form.is_foreign, nationality: this.form.nationality,
          document_type: this.form.document_type, document_country: this.form.document_country,
          document_number: this.form.document_number, patient_cpf: this.form[this.cpfField],
        });
        if (version === this.requestVersion) this.message = validation.message;
      } catch (error) {
        if (version !== this.requestVersion) return;
        this.invalid = true;
        this.message = Object.values(error.response?.data?.errors || {}).flat()[0] || 'Não foi possível validar o documento. Tente novamente.';
      }
    },
  },
};
</script>
